// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"021a9e01","513":"03bf7a3b","703":"a929ed39","787":"9597f106"}[chunkId] + ".chunk.js";
};